import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {cx} from '@emotion/css';

import BaseModal from '@fo/designSystem/BaseModal/BaseModal';
import Button, {ButtonVariant} from '@fo/components/DesignSystem/Buttons/Button/Button';
import InformationBox from '@fo/components/DesignSystem/InformationBox/InformationBox';
import {SadFaceIcon} from '@fo/root/designSystem/atoms/Icons';

import styles from './nonExistentUserModal.styles';

interface ShowModalInTwoStepsProps {
  onModalClose: () => void;
  showCreateAccountModal: () => void;
}

function NonExistentUserModal({onModalClose, showCreateAccountModal}: ShowModalInTwoStepsProps): ReactElement {
  const {formatMessage} = useIntl();

  return (
    <BaseModal onClose={onModalClose}>
      <div className={cx(styles.container)} data-testid="modal.nonExistentUserModal" id="nonExistentUserModal">
        <InformationBox
          title={formatMessage({id: 'nonExistentUserModal.title'})}
          copy={<FormattedMessage id="nonExistentUserModal.copy" />}
          className={cx(styles.informationBox)}
          copyClass={cx(styles.informationBoxCopy)}
          icon={<SadFaceIcon />}
        >
          <Button
            onClick={() => {
              onModalClose();
              showCreateAccountModal();
            }}
            variant={ButtonVariant.PRIMARY_OUTLINE}
            ariaLabel={formatMessage({id: 'phoenix.header.login.haveAccount'})}
            testId="button.nonExistentUserModal.choseAccountType"
          >
            <FormattedMessage id="createAccount.typeModal.title" />
          </Button>
        </InformationBox>
      </div>
    </BaseModal>
  );
}

export default NonExistentUserModal;
